/**
 * musicSheetLocales.js
 * Dicionários e helper de tradução agnóstico para MusicSheet (Web Component Ready).
 * Não depende de vue-i18n ou de bibliotecas externas.
 */

export const DEFAULT_LOCALES = {
  'pt-BR': {
    // Top Toolbar & Common
    'score.defaultTitle': 'Minha Partitura',
    'score.untitled': 'Sem título',
    'toolbar.play': 'Reproduzir partitura',
    'toolbar.stop': 'Parar reprodução',
    'toolbar.pause': 'Pausar reprodução',
    'toolbar.listen': 'Ouvir',
    'toolbar.stopBtn': 'Parar',
    'toolbar.tempo': 'Andamento (BPM)',
    'toolbar.keySignature': 'Tonalidade',
    'toolbar.timeSignature': 'Compasso',
    'toolbar.zoomIn': 'Aumentar Zoom',
    'toolbar.zoomOut': 'Diminuir Zoom',
    'toolbar.zoomReset': 'Redefinir Zoom',
    'toolbar.wrapMode': 'Modo de Exibição',
    'toolbar.wrapBreak': 'Quebrar Linhas',
    'toolbar.wrapSingle': 'Linha Única (Horizontal)',
    'toolbar.export': 'Exportar',
    'toolbar.import': 'Importar',
    'toolbar.save': 'Salvar',
    'toolbar.download': 'Baixar',
    'toolbar.fullscreen': 'Tela cheia',
    'toolbar.exitFullscreen': 'Sair de tela cheia',

    // Sidebar Header
    'sidebar.tools': 'Ferramentas',
    'sidebar.expand': 'Expandir painel de ferramentas',
    'sidebar.collapse': 'Minimizar painel',

    // Notes Section
    'notes.title': 'Notas',
    'notes.whole': 'Semibreve',
    'notes.wholeDesc': 'Semibreve (4 tempos)',
    'notes.half': 'Mínima',
    'notes.halfDesc': 'Mínima (2 tempos)',
    'notes.quarter': 'Semínima',
    'notes.quarterDesc': 'Semínima (1 tempo)',
    'notes.eighth': 'Colcheia',
    'notes.eighthDesc': 'Colcheia (1/2 tempo)',
    'notes.sixteenth': 'Semicolcheia',
    'notes.sixteenthDesc': 'Semicolcheia (1/4 tempo)',
    'notes.thirtySecond': 'Fusa',
    'notes.thirtySecondDesc': 'Fusa (1/8 tempo)',
    'notes.stackHint': 'Alt+clique numa nota selecionada: empilha um tom (acorde). Alt+botão direito remove o tom.',

    // Rests Section
    'rests.title': 'Pausas',
    'rests.whole': 'Pausa — 4T',
    'rests.wholeDesc': 'Pausa de Semibreve (4 tempos)',
    'rests.half': 'Pausa — 2T',
    'rests.halfDesc': 'Pausa de Mínima (2 tempos)',
    'rests.quarter': 'Pausa — 1T',
    'rests.quarterDesc': 'Pausa de Semínima (1 tempo)',
    'rests.eighth': 'Pausa — 1/2',
    'rests.eighthDesc': 'Pausa de Colcheia (1/2 tempo)',
    'rests.sixteenth': 'Pausa — 1/4',
    'rests.sixteenthDesc': 'Pausa de Semicolcheia (1/4 tempo)',
    'rests.thirtySecond': 'Pausa — 1/8',
    'rests.thirtySecondDesc': 'Pausa de Fusa (1/8 tempo)',
    'rests.multi': 'Multicompasso',
    'rests.multiDesc': 'Pausa de múltiplos compassos na pausa selecionada',
    'rests.multiPrompt': 'Número de compassos (2-32, vazio remove):',
    'modifiers.ottava8va': '8va (oitava acima)',
    'modifiers.ottava8vaDesc': 'Iniciar trecho em 8va na nota selecionada',
    'modifiers.ottava8vb': '8vb (oitava abaixo)',
    'modifiers.ottava8vbDesc': 'Iniciar trecho em 8vb na nota selecionada',
    'modifiers.ottavaEnd': 'Fim 8va/8vb',
    'modifiers.ottavaEndDesc': 'Encerrar trecho de oitava na nota selecionada',
    'voices.staff': 'Pauta {n}',
    'voices.newStaff': '+ Nova pauta',
    'voices.staffDesc': 'Pauta desta voz (vozes na mesma pauta dividem hastes)',
    'voices.tabDesc': 'Mostrar tablatura de guitarra abaixo da pauta (clique de novo p/ só TAB)',
    'voices.tabOnlyActive': 'Modo só TAB ativo (clique p/ desativar)',
    'voices.capo': 'Capo {n}',
    'voices.capoNone': 'Sem capo',
    'voices.capoDesc': 'Capotraste desta voz (transpõe a TAB, não o som)',
    'voices.transposeDesc': 'Instrumento transpositor (partitura mostra transposto, som em Dó)',
    'structure.transpose': 'Transpor',
    'structure.transposeDownDesc': 'Transpor um semitom abaixo (armadura acompanha)',
    'structure.transposeUpDesc': 'Transpor um semitom acima (armadura acompanha)',
    'structure.swing': 'Swing',
    'structure.swingDesc': 'Balanço ternário no playback (só afeta o som)',
    'structure.swingOn': 'Swing ON',
    'structure.swingOff': 'Reta',
    'structure.swingAmountDesc': 'Intensidade do swing',
    'structure.swingLight': 'Suave',
    'structure.swingMedium': 'Médio',
    'structure.swingHard': 'Forte',
    'modifiers.arpeggio': 'Arpejo',
    'modifiers.arpeggioDesc': 'Arpejo (acorde desenrolado de baixo para cima)',
    'modifiers.tremolo': 'Tremolo',
    'modifiers.tremoloDesc': 'Tremolo no hastilho (1-3 traços, visual)',
    'modifiers.breath': 'Respiração',
    'modifiers.breathDesc': 'Marca de respiração após a nota',
    'modifiers.pedalStart': 'Pedal (início)',
    'modifiers.pedalStartDesc': 'Marcar início do pedal (Ped.)',
    'modifiers.pedalEnd': 'Pedal (fim)',
    'modifiers.pedalEndDesc': 'Marcar fim do pedal (*)',
    'modifiers.navFine': 'Fine',
    'modifiers.navFineDesc': 'Marca de fim (encerra após D.S./D.C.)',
    'modifiers.navToCoda': 'To Coda',
    'modifiers.navToCodaDesc': 'Ponto de desvio para a Coda',
    'modifiers.navDsAlFine': 'D.S. al Fine',
    'modifiers.navDsAlFineDesc': 'Volta ao Segno e termina no Fine',
    'modifiers.navDcAlFine': 'D.C. al Fine',
    'modifiers.navDcAlFineDesc': 'Volta ao início e termina no Fine',
    'modifiers.navDsAlCoda': 'D.S. al Coda',
    'modifiers.navDsAlCodaDesc': 'Volta ao Segno e desvia na To Coda',
    'modifiers.navDcAlCoda': 'D.C. al Coda',
    'modifiers.navDcAlCodaDesc': 'Volta ao início e desvia na To Coda',

    // Accidentals Section
    'accidentals.title': 'Acidentes',
    'accidentals.natural': 'Natural',
    'accidentals.sharp': 'Sustenido',
    'accidentals.flat': 'Bemol',
    'accidentals.doubleSharp': 'Dobrado Sustenido',
    'accidentals.doubleFlat': 'Dobrado Bemol',

    // Clefs Section
    'clefs.title': 'Clave Inline',
    'clefs.inlineTitle': 'Clave na Nota (Inline)',
    'clefs.treble': 'Sol',
    'clefs.trebleDesc': 'Inserir Clave de Sol Inline',
    'clefs.bass': 'Fá',
    'clefs.bassDesc': 'Inserir Clave de Fá Inline',
    'clefs.alto': 'Dó',
    'clefs.altoDesc': 'Inserir Clave de Dó (Alto) Inline',
    'clefs.tenor': 'Tenor',
    'clefs.tenorDesc': 'Inserir Clave de Tenor Inline',

    // Noteheads Section
    'noteheads.title': 'Cabeça da Nota',
    'noteheads.normalDesc': 'Cabeça oval padrão',
    'noteheads.xDesc': 'Cabeça em X (percussão / abafada)',
    'noteheads.diamondDesc': 'Cabeça losango (harmônico)',
    'noteheads.slashDesc': 'Cabeça barra (notação rítmica)',

    // Modifiers & Articulations Section
    'modifiers.title': 'Articulações & Ponto',
    'modifiers.dotted': 'Nota Pontuada',
    'modifiers.dottedDesc': 'Ponto de Aumento (Multiplica duração por 1.5)',
    'modifiers.staccato': 'Staccato',
    'modifiers.staccatoDesc': 'Staccato (ponto acima/abaixo da nota)',
    'modifiers.accent': 'Acento (>)',
    'modifiers.accentDesc': 'Acento (>)',
    'modifiers.marcato': 'Marcato (^)',
    'modifiers.marcatoDesc': 'Marcato (^)',
    'modifiers.graceNote': 'Grace Note ({g})',
    'modifiers.graceNoteDesc': 'Nota de Graça / Apoiada (Grace Note)',
    'modifiers.glissando': 'Glissando',
    'modifiers.glissandoDesc': 'Glissando (linha ondulada até a próxima nota)',
    'modifiers.cautionary': 'Acidente Cortesia',
    'modifiers.cautionaryDesc': 'Acidente de Precaução / Cortesia (entre parênteses)',
    'modifiers.fermata': 'Fermata',
    'modifiers.fermataDesc': 'Fermata (𝄐)',
    'modifiers.downBow': 'Down-bow (⨅)',
    'modifiers.downBowDesc': 'Arcada para Baixo / Talão (Down-bow 𝄠)',
    'modifiers.upBow': 'Up-bow (V)',
    'modifiers.upBowDesc': 'Arcada para Cima / Ponta (Up-bow 𝄡)',
    'modifiers.tuplet': 'Tercina (3:2)',
    'modifiers.tupletDesc': 'Tercina (Quiáltera de 3 notas)',
    'modifiers.coda': 'Coda',
    'modifiers.codaDesc': 'Inserir Coda (𝄌)',
    'modifiers.segno': 'Segno',
    'modifiers.segnoDesc': 'Inserir Segno (𝄋)',
    'modifiers.trill': 'Trinado (Trill)',
    'modifiers.trillDesc': 'Trinado (tr)',
    'modifiers.turn': 'Grupeto (Turn)',
    'modifiers.turnDesc': 'Grupeto (Turn / ~)',
    'modifiers.mordent': 'Mordente',
    'modifiers.mordentDesc': 'Mordente',
    'modifiers.crescendo': 'Crescendo (<)',
    'modifiers.crescendoDesc': 'Crescendo (<)',
    'modifiers.diminuendo': 'Diminuendo (>)',
    'modifiers.diminuendoDesc': 'Diminuendo (>)',
    'modifiers.hairpinEnd': 'Fim de Regulador',
    'modifiers.hairpinEndDesc': 'Fim de Expressão / Hairpin',

    // Ties & Slurs Section
    'ligatures.title': 'Ligaduras',
    'ligatures.tie': 'Lig. Prolongamento',
    'ligatures.tieDesc': 'Ligar nota à seguinte (Sustain / Prolongamento)',
    'ligatures.slur': 'Lig. Expressão (Slur)',
    'ligatures.slurDesc': 'Alternar início/fim de fraseado (Legato / Expressão)',

    // Tablature Articulations Section
    'tabArticulations.title': 'Articulações TAB',
    'tabArticulations.slideUp': 'Slide Up ( / )',
    'tabArticulations.slideUpDesc': 'Slide ascendente na mesma corda',
    'tabArticulations.slideDown': 'Slide Down ( \\ )',
    'tabArticulations.slideDownDesc': 'Slide descendente na mesma corda',
    'tabArticulations.bendFull': 'Bend Full (1)',
    'tabArticulations.bendFullDesc': 'Bend de 1 Tom (Full)',
    'tabArticulations.bendHalf': 'Bend 1/2',
    'tabArticulations.bendHalfDesc': 'Bend de meio tom (1/2)',
    'tabArticulations.bendQuarter': 'Microbend 1/4',
    'tabArticulations.bendQuarterDesc': 'Microbend / Blues curl (1/4 tom)',
    'tabArticulations.bendRelease': 'Bend & Release',
    'tabArticulations.bendReleaseDesc': 'Bend seguido de retorno à nota original',
    'tabArticulations.hammerPull': 'Hammer / Pull (H/P)',
    'tabArticulations.hammerPullDesc': 'Ligadura de Hammer-on (H) ou Pull-off (P)',
    'tabArticulations.vibrato': 'Vibrato ( ~ )',
    'tabArticulations.vibratoDesc': 'Vibrato na nota da tablatura',
    'tabArticulations.harmonic': 'Harmônico ( < > )',
    'tabArticulations.harmonicDesc': 'Harmônico natural ou artificial (<casa>)',
    'tabArticulations.deadNote': 'Dead Note ( X )',
    'tabArticulations.deadNoteDesc': 'Nota abafada percussiva',
    'tabArticulations.ghostNote': 'Ghost Note ( )',
    'tabArticulations.ghostNoteDesc': 'Nota fantasma tocada suavemente',
    'tabArticulations.palmMute': 'Palm Mute (P.M.)',
    'tabArticulations.palmMuteDesc': 'Abafamento com a palma da mão',
    'tabArticulations.clear': 'Limpar Articulações TAB',
    'tabArticulations.clearDesc': 'Remover efeitos e articulações de TAB da nota',
    'tabArticulations.fret': 'Traste',
    'tabArticulations.string': 'Corda',
    'tabArticulations.editHint': 'Clique na corda da TAB para adicionar notas. Digite 0–24 para alterar o traste e use as setas ↑↓←→ para navegar.',
    'tabArticulations.fretDesc': 'Número do traste no braço da guitarra/violão',

    // Chords Section
    'chords.title': 'Acordes / Cifras',
    'chords.placeholder': 'Ex: C, G7, Em, Am...',
    'chords.apply': 'Ok',
    'chords.applyDesc': 'Aplicar cifra na nota selecionada',
    'chords.remove': 'Remover Cifra',
    'chords.guitarDiagrams': '🎸 Diagramas de Violão',
    'chords.guitarDiagramsDesc': 'Alternar exibição dos diagramas de acordes de violão',
    'chords.on': 'ON',
    'chords.off': 'OFF',

    // Structure Section
    'structure.title': 'Estrutura',
    'structure.clef': 'Clave',
    'structure.clefTreble': 'Sol (Treble)',
    'structure.clefBass': 'Fá (Bass)',
    'structure.clefAlto': 'Dó (Alto - 3ª Linha)',
    'structure.clefTenor': 'Dó (Tenor - 4ª Linha)',
    'structure.clefPercussion': 'Percussão',
    'drums.title': 'Bateria',
    'drums.kick': 'Bumbo',
    'drums.kickDesc': 'Bumbo (insere na voz ativa)',
    'drums.snare': 'Caixa',
    'drums.snareDesc': 'Caixa (insere na voz ativa)',
    'drums.hihat': 'Chimbal',
    'drums.hihatDesc': 'Chimbal fechado (insere na voz ativa)',
    'drums.hihatOpen': 'Chimbal aberto',
    'drums.hihatOpenDesc': 'Chimbal aberto (insere na voz ativa)',
    'drums.tomHigh': 'Tom 1',
    'drums.tomHighDesc': 'Tom agudo (insere na voz ativa)',
    'drums.tomMid': 'Tom 2',
    'drums.tomMidDesc': 'Tom médio (insere na voz ativa)',
    'drums.tomFloor': 'Surdo',
    'drums.tomFloorDesc': 'Surdo de chão (insere na voz ativa)',
    'drums.crash': 'Ataque',
    'drums.crashDesc': 'Prato de ataque (insere na voz ativa)',
    'drums.ride': 'Condução',
    'drums.rideDesc': 'Prato de condução (insere na voz ativa)',
    'structure.timeSignature': 'Compasso',
    'structure.keySignature': 'Tonalidade',
    'structure.major': 'Maior',
    'structure.minor': 'Menor',
    'structure.lineBreak': 'Quebra de Linha',
    'structure.lineBreakDesc': 'Inserir quebra de sistema nesta nota',
    'structure.break': 'Quebrar',
    'structure.midChanges': 'Mudanças no compasso',
    'structure.midKey': 'Armadura aqui',
    'structure.midKeyDesc': 'Inserir mudança de armadura no compasso da nota selecionada (usa o Tom acima)',
    'structure.midTime': 'Fórmula aqui',
    'structure.midTimeDesc': 'Inserir mudança de fórmula no compasso da nota selecionada (usa o Compasso acima)',
    'structure.rehearsal': 'Marca de ensaio',
    'structure.rehearsalDesc': 'Definir marca de ensaio na nota selecionada (vazio remove)',
    'structure.rehearsalPrompt': 'Letra da marca de ensaio (vazio remove):',
    'structure.tempoChanges': 'Andamento',
    'structure.tempoBpm': 'BPM aqui',
    'structure.tempoBpmDesc': 'Mudança súbita de BPM no compasso da nota selecionada',
    'structure.tempoBpmPrompt': 'BPM no compasso (igual remove):',
    'structure.rit': 'rit.',
    'structure.ritDesc': 'Ritenuto gradual até o fim',
    'structure.ritPrompt': 'BPM alvo do rit.:',
    'structure.accel': 'accel.',
    'structure.accelDesc': 'Accelerando gradual até o fim',
    'structure.accelPrompt': 'BPM alvo do accel.:',
    'print.pageOf': 'Página {n} de {total}',

    // Lyrics Section
    'lyrics.title': 'Letra (Lyrics)',
    'lyrics.helper': 'Separe sílabas com espaço ou hífen:',
    'lyrics.placeholder': 'Ex: Bri-lha bri-lha es-tre-li-nha',
    'lyrics.apply': 'Aplicar Letra',
    'lyrics.applyDesc': 'Distribuir sílabas nas notas da voz ativa',
    'lyrics.clear': 'Limpar',
    'lyrics.clearDesc': 'Remover letras da voz ativa',
    'lyrics.verse1': 'Verso 1',
    'lyrics.verse1Desc': 'Aplicar letra ao verso 1',
    'lyrics.verse2': 'Verso 2',
    'lyrics.verse2Desc': 'Aplicar letra ao verso 2',

    // Voices Section
    'voices.title': 'Vozes',
    'voices.select': 'Selecionar {name}',
    'voices.hide': 'Ocultar',
    'voices.show': 'Mostrar',
    'voices.add': 'Adicionar',
    'voices.addDesc': 'Adicionar voz',
    'voices.part': 'Parte',
    'voices.allParts': 'Todas as vozes',
    'voices.partDesc': 'Isolar uma voz para estudo, playback, impressão e exportação (não altera a partitura)',
    'voices.remove': 'Remover',
    'voices.removeDesc': 'Remover voz ativa',

    // Actions Section
    'actions.title': 'Ações',
    'actions.undo': 'Desfazer',
    'actions.undoDesc': 'Desfazer (Ctrl+Z)',
    'actions.redo': 'Refazer',
    'actions.redoDesc': 'Refazer (Ctrl+Y)',
    'actions.clear': 'Limpar',
    'actions.clearDesc': 'Limpar partitura',
    'actions.remove': 'Remover',
    'tab.fretDown': '-1 Traste',
    'tab.fretUp': '+1 Traste',

    // Instruments
    'instruments.keys': 'Teclas',
    'instruments.grandPiano': 'Piano de Cauda',
    'instruments.brightPiano': 'Piano Brilhante',
    'instruments.harpsichord': 'Cravo (Harpsichord)',
    'instruments.churchOrgan': 'Órgão de Tubos',
    'instruments.strings': 'Cordas',
    'instruments.nylonGuitar': 'Violão (Nylon)',
    'instruments.steelGuitar': 'Violão (Aço)',
    'instruments.violin': 'Violino',
    'instruments.cello': 'Violoncelo',
    'instruments.stringEnsemble': 'Orquestra de Cordas',
    'instruments.winds': 'Sopros & Metais',
    'instruments.flute': 'Flauta Transversal',
    'instruments.trumpet': 'Trompete',
    'instruments.percussion': 'Percussão',
    'instruments.drumKit': 'Bateria (Drum Kit)',

    // Footer
    'footer.notes': 'Notas',
    'footer.measures': 'Compassos',
    'footer.tempo': 'Tempo',
    'footer.rightClickHint': 'Clique com botão direito numa nota para remover',

    // Modals (Import / Export)
    'modal.importTitle': 'Importar Partitura',
    'modal.exportTitle': 'Exportar Partitura',
    'modal.loadSample': 'Carregar Exemplo',
    'modal.pastePrompt': 'Cole o conteúdo {format}:',
    'modal.cancel': 'Cancelar',
    'modal.processAndLoad': 'Processar e Carregar',
    'modal.copy': 'Copiar',
    'modal.downloadFile': 'Baixar Arquivo',
    'modal.copied': 'Copiado para a área de transferência!',

    // Dialogs / Prompts / Notifications
    'dialog.clearConfirm': 'Tem certeza que deseja limpar a partitura? Esta ação removerá todas as notas inseridas.',
    'dialog.exportSuccess': 'Partitura exportada com sucesso.',
    'dialog.importError': 'Erro ao importar partitura.',
    'dialog.emptyScore': 'Partitura vazia.'
  },

  'en': {
    // Top Toolbar & Common
    'score.defaultTitle': 'My Sheet Music',
    'score.untitled': 'Untitled',
    'toolbar.play': 'Play score',
    'toolbar.stop': 'Stop playback',
    'toolbar.pause': 'Pause playback',
    'toolbar.listen': 'Play',
    'toolbar.stopBtn': 'Stop',
    'toolbar.tempo': 'Tempo (BPM)',
    'toolbar.keySignature': 'Key Signature',
    'toolbar.timeSignature': 'Time Signature',
    'toolbar.zoomIn': 'Zoom In',
    'toolbar.zoomOut': 'Zoom Out',
    'toolbar.zoomReset': 'Reset Zoom',
    'toolbar.wrapMode': 'View Mode',
    'toolbar.wrapBreak': 'Wrap Lines',
    'toolbar.wrapSingle': 'Single Line (Horizontal)',
    'toolbar.export': 'Export',
    'toolbar.import': 'Import',
    'toolbar.save': 'Save',
    'toolbar.download': 'Download',
    'toolbar.fullscreen': 'Fullscreen',
    'toolbar.exitFullscreen': 'Exit fullscreen',

    // Sidebar Header
    'sidebar.tools': 'Tools',
    'sidebar.expand': 'Expand tools panel',
    'sidebar.collapse': 'Collapse panel',

    // Notes Section
    'notes.title': 'Notes',
    'notes.whole': 'Whole Note',
    'notes.wholeDesc': 'Whole Note (4 beats)',
    'notes.half': 'Half Note',
    'notes.halfDesc': 'Half Note (2 beats)',
    'notes.quarter': 'Quarter Note',
    'notes.quarterDesc': 'Quarter Note (1 beat)',
    'notes.eighth': 'Eighth Note',
    'notes.eighthDesc': 'Eighth Note (1/2 beat)',
    'notes.sixteenth': 'Sixteenth Note',
    'notes.sixteenthDesc': 'Sixteenth Note (1/4 beat)',
    'notes.thirtySecond': 'Thirty-second Note',
    'notes.thirtySecondDesc': 'Thirty-second Note (1/8 beat)',
    'notes.stackHint': 'Alt+click on a selected note: stack a chord tone. Alt+right-click removes the tone.',

    // Rests Section
    'rests.title': 'Rests',
    'rests.whole': 'Rest — 4B',
    'rests.wholeDesc': 'Whole Rest (4 beats)',
    'rests.half': 'Rest — 2B',
    'rests.halfDesc': 'Half Rest (2 beats)',
    'rests.quarter': 'Rest — 1B',
    'rests.quarterDesc': 'Quarter Rest (1 beat)',
    'rests.eighth': 'Rest — 1/2',
    'rests.eighthDesc': 'Eighth Rest (1/2 beat)',
    'rests.sixteenth': 'Rest — 1/4',
    'rests.sixteenthDesc': 'Sixteenth Rest (1/4 beat)',
    'rests.thirtySecond': 'Rest — 1/8',
    'rests.thirtySecondDesc': 'Thirty-second Rest (1/8 beat)',
    'rests.multi': 'Multi-measure',
    'rests.multiDesc': 'Multi-measure rest on the selected rest',
    'rests.multiPrompt': 'Number of measures (2-32, empty removes):',
    'modifiers.ottava8va': '8va (octave up)',
    'modifiers.ottava8vaDesc': 'Start 8va passage at the selected note',
    'modifiers.ottava8vb': '8vb (octave down)',
    'modifiers.ottava8vbDesc': 'Start 8vb passage at the selected note',
    'modifiers.ottavaEnd': 'End 8va/8vb',
    'modifiers.ottavaEndDesc': 'End octave passage at the selected note',
    'voices.staff': 'Staff {n}',
    'voices.newStaff': '+ New staff',
    'voices.staffDesc': 'Staff of this voice (voices sharing a staff split stems)',
    'voices.tabDesc': 'Show guitar tablature below the staff (click again for TAB-only)',
    'voices.tabOnlyActive': 'TAB-only mode active (click to disable)',
    'voices.capo': 'Capo {n}',
    'voices.capoNone': 'No capo',
    'voices.capoDesc': 'Capo for this voice (transposes TAB, not sound)',
    'voices.transposeDesc': 'Transposing instrument (part shows transposed, concert sound)',
    'structure.transpose': 'Transpose',
    'structure.transposeDownDesc': 'Transpose down one semitone (key follows)',
    'structure.transposeUpDesc': 'Transpose up one semitone (key follows)',
    'structure.swing': 'Swing',
    'structure.swingDesc': 'Triplet feel on playback (sound only)',
    'structure.swingOn': 'Swing ON',
    'structure.swingOff': 'Straight',
    'structure.swingAmountDesc': 'Swing amount',
    'structure.swingLight': 'Light',
    'structure.swingMedium': 'Medium',
    'structure.swingHard': 'Hard',
    'modifiers.arpeggio': 'Arpeggio',
    'modifiers.arpeggioDesc': 'Arpeggio (bottom-up strummed chord)',
    'modifiers.tremolo': 'Tremolo',
    'modifiers.tremoloDesc': 'Stem tremolo (1-3 slashes, visual only)',
    'modifiers.breath': 'Breath mark',
    'modifiers.breathDesc': 'Breath mark after the note',
    'modifiers.pedalStart': 'Pedal (start)',
    'modifiers.pedalStartDesc': 'Mark pedal start (Ped.)',
    'modifiers.pedalEnd': 'Pedal (end)',
    'modifiers.pedalEndDesc': 'Mark pedal release (*)',
    'modifiers.navFine': 'Fine',
    'modifiers.navFineDesc': 'End mark (stops after D.S./D.C.)',
    'modifiers.navToCoda': 'To Coda',
    'modifiers.navToCodaDesc': 'Jump point to the Coda',
    'modifiers.navDsAlFine': 'D.S. al Fine',
    'modifiers.navDsAlFineDesc': 'Back to Segno, end at Fine',
    'modifiers.navDcAlFine': 'D.C. al Fine',
    'modifiers.navDcAlFineDesc': 'Back to start, end at Fine',
    'modifiers.navDsAlCoda': 'D.S. al Coda',
    'modifiers.navDsAlCodaDesc': 'Back to Segno, divert at To Coda',
    'modifiers.navDcAlCoda': 'D.C. al Coda',
    'modifiers.navDcAlCodaDesc': 'Back to start, divert at To Coda',

    // Accidentals Section
    'accidentals.title': 'Accidentals',
    'accidentals.natural': 'Natural',
    'accidentals.sharp': 'Sharp',
    'accidentals.flat': 'Flat',
    'accidentals.doubleSharp': 'Double Sharp',
    'accidentals.doubleFlat': 'Double Flat',

    // Clefs Section
    'clefs.title': 'Inline Clef',
    'clefs.inlineTitle': 'Inline Clef on Note',
    'clefs.treble': 'Treble',
    'clefs.trebleDesc': 'Insert Inline Treble Clef',
    'clefs.bass': 'Bass',
    'clefs.bassDesc': 'Insert Inline Bass Clef',
    'clefs.alto': 'Alto',
    'clefs.altoDesc': 'Insert Inline Alto Clef',
    'clefs.tenor': 'Tenor',
    'clefs.tenorDesc': 'Insert Inline Tenor Clef',

    // Noteheads Section
    'noteheads.title': 'Notehead',
    'noteheads.normalDesc': 'Standard oval notehead',
    'noteheads.xDesc': 'X notehead (percussion / muted)',
    'noteheads.diamondDesc': 'Diamond notehead (harmonic)',
    'noteheads.slashDesc': 'Slash notehead (rhythmic notation)',

    // Modifiers & Articulations Section
    'modifiers.title': 'Articulations & Dot',
    'modifiers.dotted': 'Dotted Note',
    'modifiers.dottedDesc': 'Augmentation Dot (Multiply duration by 1.5)',
    'modifiers.staccato': 'Staccato',
    'modifiers.staccatoDesc': 'Staccato (dot above/below note)',
    'modifiers.accent': 'Accent (>)',
    'modifiers.accentDesc': 'Accent (>)',
    'modifiers.marcato': 'Marcato (^)',
    'modifiers.marcatoDesc': 'Marcato (^)',
    'modifiers.graceNote': 'Grace Note ({g})',
    'modifiers.graceNoteDesc': 'Grace Note ({g})',
    'modifiers.glissando': 'Glissando',
    'modifiers.glissandoDesc': 'Glissando (wavy line to next note)',
    'modifiers.cautionary': 'Cautionary Accidental',
    'modifiers.cautionaryDesc': 'Cautionary / Courtesy Accidental (parenthesized)',
    'modifiers.fermata': 'Fermata',
    'modifiers.fermataDesc': 'Fermata (𝄐)',
    'modifiers.downBow': 'Down-bow (⨅)',
    'modifiers.downBowDesc': 'Down-bow (⨅)',
    'modifiers.upBow': 'Up-bow (V)',
    'modifiers.upBowDesc': 'Up-bow (V)',
    'modifiers.tuplet': 'Tuplet (3:2)',
    'modifiers.tupletDesc': 'Tuplet (3-note tuplet)',
    'modifiers.coda': 'Coda',
    'modifiers.codaDesc': 'Insert Coda (𝄌)',
    'modifiers.segno': 'Segno',
    'modifiers.segnoDesc': 'Insert Segno (𝄋)',
    'modifiers.trill': 'Trill (tr)',
    'modifiers.trillDesc': 'Trill (tr)',
    'modifiers.turn': 'Turn',
    'modifiers.turnDesc': 'Turn (~)',
    'modifiers.mordent': 'Mordent',
    'modifiers.mordentDesc': 'Mordent',
    'modifiers.crescendo': 'Crescendo (<)',
    'modifiers.crescendoDesc': 'Crescendo (<)',
    'modifiers.diminuendo': 'Diminuendo (>)',
    'modifiers.diminuendoDesc': 'Diminuendo (>)',
    'modifiers.hairpinEnd': 'End of Hairpin',
    'modifiers.hairpinEndDesc': 'End of Dynamic Expression',

    // Ties & Slurs Section
    'ligatures.title': 'Ties & Slurs',
    'ligatures.tie': 'Tie',
    'ligatures.tieDesc': 'Tie note to next (Sustain)',
    'ligatures.slur': 'Slur (Legato)',
    'ligatures.slurDesc': 'Toggle phrasing slur start/end',

    // Tablature Articulations Section
    'tabArticulations.title': 'TAB Articulations',
    'tabArticulations.slideUp': 'Slide Up ( / )',
    'tabArticulations.slideUpDesc': 'Ascending slide on the same string',
    'tabArticulations.slideDown': 'Slide Down ( \\ )',
    'tabArticulations.slideDownDesc': 'Descending slide on the same string',
    'tabArticulations.bendFull': 'Bend Full (1)',
    'tabArticulations.bendFullDesc': 'Full step bend (1 whole tone)',
    'tabArticulations.bendHalf': 'Bend 1/2',
    'tabArticulations.bendHalfDesc': 'Half step bend (semitone)',
    'tabArticulations.bendQuarter': 'Microbend 1/4',
    'tabArticulations.bendQuarterDesc': 'Quarter step blues bend',
    'tabArticulations.bendRelease': 'Bend & Release',
    'tabArticulations.bendReleaseDesc': 'Bend and release back to original fret',
    'tabArticulations.hammerPull': 'Hammer / Pull (H/P)',
    'tabArticulations.hammerPullDesc': 'Hammer-on (H) or Pull-off (P) legato slur',
    'tabArticulations.vibrato': 'Vibrato ( ~ )',
    'tabArticulations.vibratoDesc': 'Fretboard or whammy vibrato',
    'tabArticulations.harmonic': 'Harmonic ( < > )',
    'tabArticulations.harmonicDesc': 'Natural or pinch harmonic (<fret>)',
    'tabArticulations.deadNote': 'Dead Note ( X )',
    'tabArticulations.deadNoteDesc': 'Muted percussive string strike',
    'tabArticulations.ghostNote': 'Ghost Note ( )',
    'tabArticulations.ghostNoteDesc': 'Softly played ghost note',
    'tabArticulations.palmMute': 'Palm Mute (P.M.)',
    'tabArticulations.palmMuteDesc': 'Right-hand palm mute technique',
    'tabArticulations.clear': 'Clear TAB Articulations',
    'tabArticulations.clearDesc': 'Remove TAB effects and articulations from note',
    'tabArticulations.fret': 'Fret',
    'tabArticulations.string': 'String',
    'tabArticulations.editHint': 'Click TAB string to add notes. Type 0–24 to change fret and use ↑↓←→ arrows to navigate.',
    'tabArticulations.fretDesc': 'Fret number on guitar fretboard',

    // Chords Section
    'chords.title': 'Chords & Symbols',
    'chords.placeholder': 'E.g.: C, G7, Em, Am...',
    'chords.apply': 'Apply',
    'chords.applyDesc': 'Apply chord symbol to selected note',
    'chords.remove': 'Remove Chord',
    'chords.guitarDiagrams': '🎸 Guitar Chord Frames',
    'chords.guitarDiagramsDesc': 'Toggle guitar chord frame diagrams',
    'chords.on': 'ON',
    'chords.off': 'OFF',

    // Structure Section
    'structure.title': 'Structure',
    'structure.clef': 'Clef',
    'structure.clefTreble': 'Treble (G)',
    'structure.clefBass': 'Bass (F)',
    'structure.clefAlto': 'Alto (C - 3rd line)',
    'structure.clefTenor': 'Tenor (C - 4th line)',
    'structure.clefPercussion': 'Percussion',
    'drums.title': 'Drums',
    'drums.kick': 'Kick',
    'drums.kickDesc': 'Kick drum (inserts into active voice)',
    'drums.snare': 'Snare',
    'drums.snareDesc': 'Snare drum (inserts into active voice)',
    'drums.hihat': 'Hi-hat',
    'drums.hihatDesc': 'Closed hi-hat (inserts into active voice)',
    'drums.hihatOpen': 'Open hi-hat',
    'drums.hihatOpenDesc': 'Open hi-hat (inserts into active voice)',
    'drums.tomHigh': 'High tom',
    'drums.tomHighDesc': 'High tom (inserts into active voice)',
    'drums.tomMid': 'Mid tom',
    'drums.tomMidDesc': 'Mid tom (inserts into active voice)',
    'drums.tomFloor': 'Floor tom',
    'drums.tomFloorDesc': 'Floor tom (inserts into active voice)',
    'drums.crash': 'Crash',
    'drums.crashDesc': 'Crash cymbal (inserts into active voice)',
    'drums.ride': 'Ride',
    'drums.rideDesc': 'Ride cymbal (inserts into active voice)',
    'structure.timeSignature': 'Time Signature',
    'structure.keySignature': 'Key Signature',
    'structure.major': 'Major',
    'structure.minor': 'Minor',
    'structure.lineBreak': 'System Line Break',
    'structure.lineBreakDesc': 'Insert system line break on this note',
    'structure.break': 'Break Line',
    'structure.midChanges': 'Mid-piece changes',
    'structure.midKey': 'Key here',
    'structure.midKeyDesc': 'Insert key change at the selected note measure (uses Key above)',
    'structure.midTime': 'Meter here',
    'structure.midTimeDesc': 'Insert time change at the selected note measure (uses Meter above)',
    'structure.rehearsal': 'Rehearsal mark',
    'structure.rehearsalDesc': 'Set rehearsal mark on the selected note (empty removes)',
    'structure.rehearsalPrompt': 'Rehearsal mark letter (empty removes):',
    'structure.tempoChanges': 'Tempo',
    'structure.tempoBpm': 'BPM here',
    'structure.tempoBpmDesc': 'Sudden BPM change at the selected note measure',
    'structure.tempoBpmPrompt': 'BPM at measure (same removes):',
    'structure.rit': 'rit.',
    'structure.ritDesc': 'Gradual ritenuto to the end',
    'structure.ritPrompt': 'Target BPM for rit.:',
    'structure.accel': 'accel.',
    'structure.accelDesc': 'Gradual accelerando to the end',
    'structure.accelPrompt': 'Target BPM for accel.:',
    'print.pageOf': 'Page {n} of {total}',

    // Lyrics Section
    'lyrics.title': 'Lyrics',
    'lyrics.helper': 'Separate syllables with space or hyphen:',
    'lyrics.placeholder': 'E.g.: Twin-kle twin-kle lit-tle star',
    'lyrics.apply': 'Apply Lyrics',
    'lyrics.applyDesc': 'Distribute syllables across active voice notes',
    'lyrics.clear': 'Clear',
    'lyrics.clearDesc': 'Remove lyrics from active voice',
    'lyrics.verse1': 'Verse 1',
    'lyrics.verse1Desc': 'Apply lyrics to verse 1',
    'lyrics.verse2': 'Verse 2',
    'lyrics.verse2Desc': 'Apply lyrics to verse 2',

    // Voices Section
    'voices.title': 'Voices',
    'voices.select': 'Select {name}',
    'voices.hide': 'Hide',
    'voices.show': 'Show',
    'voices.add': 'Add',
    'voices.addDesc': 'Add voice',
    'voices.part': 'Part',
    'voices.allParts': 'All voices',
    'voices.partDesc': 'Isolate one voice for study, playback, print and export (score unchanged)',
    'voices.remove': 'Remove',
    'voices.removeDesc': 'Remove active voice',

    // Actions Section
    'actions.title': 'Actions',
    'actions.undo': 'Undo',
    'actions.undoDesc': 'Undo (Ctrl+Z)',
    'actions.redo': 'Redo',
    'actions.redoDesc': 'Redo (Ctrl+Y)',
    'actions.clear': 'Clear',
    'actions.clearDesc': 'Clear score',
    'actions.remove': 'Remove',
    'tab.fretDown': '-1 Fret',
    'tab.fretUp': '+1 Fret',

    // Instruments
    'instruments.keys': 'Keyboards',
    'instruments.grandPiano': 'Grand Piano',
    'instruments.brightPiano': 'Bright Piano',
    'instruments.harpsichord': 'Harpsichord',
    'instruments.churchOrgan': 'Church Organ',
    'instruments.strings': 'Strings',
    'instruments.nylonGuitar': 'Acoustic Guitar (Nylon)',
    'instruments.steelGuitar': 'Acoustic Guitar (Steel)',
    'instruments.violin': 'Violin',
    'instruments.cello': 'Cello',
    'instruments.stringEnsemble': 'String Ensemble',
    'instruments.winds': 'Winds & Brass',
    'instruments.flute': 'Flute',
    'instruments.trumpet': 'Trumpet',
    'instruments.percussion': 'Percussion',
    'instruments.drumKit': 'Drum Kit',

    // Footer
    'footer.notes': 'Notes',
    'footer.measures': 'Measures',
    'footer.tempo': 'Tempo',
    'footer.rightClickHint': 'Right-click on a note to delete',

    // Modals (Import / Export)
    'modal.importTitle': 'Import Score',
    'modal.exportTitle': 'Export Score',
    'modal.loadSample': 'Load Sample',
    'modal.pastePrompt': 'Paste {format} content:',
    'modal.cancel': 'Cancel',
    'modal.processAndLoad': 'Process & Load',
    'modal.copy': 'Copy',
    'modal.downloadFile': 'Download File',
    'modal.copied': 'Copied to clipboard!',

    // Dialogs / Prompts / Notifications
    'dialog.clearConfirm': 'Are you sure you want to clear the score? This will remove all notes.',
    'dialog.exportSuccess': 'Score exported successfully.',
    'dialog.importError': 'Error importing score.',
    'dialog.emptyScore': 'Empty score.'
  },

  'es': {
    // Top Toolbar & Common
    'score.defaultTitle': 'Mi Partitura',
    'score.untitled': 'Sin título',
    'toolbar.play': 'Reproducir partitura',
    'toolbar.stop': 'Detener reproducción',
    'toolbar.pause': 'Pausar reproducción',
    'toolbar.listen': 'Escuchar',
    'toolbar.stopBtn': 'Detener',
    'toolbar.tempo': 'Tempo (BPM)',
    'toolbar.keySignature': 'Tonalidad',
    'toolbar.timeSignature': 'Compás',
    'toolbar.zoomIn': 'Aumentar Zoom',
    'toolbar.zoomOut': 'Disminuir Zoom',
    'toolbar.zoomReset': 'Restablecer Zoom',
    'toolbar.wrapMode': 'Modo de Vista',
    'toolbar.wrapBreak': 'Ajustar Líneas',
    'toolbar.wrapSingle': 'Línea Única (Horizontal)',
    'toolbar.export': 'Exportar',
    'toolbar.import': 'Importar',
    'toolbar.save': 'Guardar',
    'toolbar.download': 'Descargar',
    'toolbar.fullscreen': 'Pantalla completa',
    'toolbar.exitFullscreen': 'Salir de pantalla completa',

    // Sidebar Header
    'sidebar.tools': 'Herramientas',
    'sidebar.expand': 'Expandir panel de herramientas',
    'sidebar.collapse': 'Minimizar panel',

    // Notes Section
    'notes.title': 'Notas',
    'notes.whole': 'Redonda',
    'notes.wholeDesc': 'Redonda (4 tiempos)',
    'notes.half': 'Blanca',
    'notes.halfDesc': 'Blanca (2 tiempos)',
    'notes.quarter': 'Negra',
    'notes.quarterDesc': 'Negra (1 tiempo)',
    'notes.eighth': 'Corchea',
    'notes.eighthDesc': 'Corchea (1/2 tiempo)',
    'notes.sixteenth': 'Semicorchea',
    'notes.sixteenthDesc': 'Semicorchea (1/4 tiempo)',
    'notes.thirtySecond': 'Fusa',
    'notes.thirtySecondDesc': 'Fusa (1/8 tiempo)',
    'notes.stackHint': 'Alt+clic en una nota seleccionada: apila un tono (acorde). Alt+clic derecho elimina el tono.',

    // Rests Section
    'rests.title': 'Silencios',
    'rests.whole': 'Silencio — 4T',
    'rests.wholeDesc': 'Silencio de Redonda (4 tiempos)',
    'rests.half': 'Silencio — 2T',
    'rests.halfDesc': 'Silencio de Blanca (2 tiempos)',
    'rests.quarter': 'Silencio — 1T',
    'rests.quarterDesc': 'Silencio de Negra (1 tiempo)',
    'rests.eighth': 'Silencio — 1/2',
    'rests.eighthDesc': 'Silencio de Corchea (1/2 tiempo)',
    'rests.sixteenth': 'Silencio — 1/4',
    'rests.sixteenthDesc': 'Silencio de Semicorchea (1/4 tiempo)',
    'rests.thirtySecond': 'Silencio — 1/8',
    'rests.thirtySecondDesc': 'Silencio de Fusa (1/8 tiempo)',
    'rests.multi': 'Multicompás',
    'rests.multiDesc': 'Silencio de múltiples compases en el silencio seleccionado',
    'rests.multiPrompt': 'Número de compases (2-32, vacío elimina):',
    'modifiers.ottava8va': '8va (octava arriba)',
    'modifiers.ottava8vaDesc': 'Iniciar pasaje en 8va en la nota seleccionada',
    'modifiers.ottava8vb': '8vb (octava abajo)',
    'modifiers.ottava8vbDesc': 'Iniciar pasaje en 8vb en la nota seleccionada',
    'modifiers.ottavaEnd': 'Fin 8va/8vb',
    'modifiers.ottavaEndDesc': 'Terminar pasaje de octava en la nota seleccionada',
    'voices.staff': 'Pentagrama {n}',
    'voices.newStaff': '+ Nuevo pentagrama',
    'voices.staffDesc': 'Pentagrama de esta voz (las voces compartidas dividen plicas)',
    'voices.tabDesc': 'Mostrar tablatura de guitarra bajo el pentagrama (clic de nuevo p/ solo TAB)',
    'voices.tabOnlyActive': 'Modo solo TAB activo (clic p/ desactivar)',
    'voices.capo': 'Capo {n}',
    'voices.capoNone': 'Sin capo',
    'voices.capoDesc': 'Capotraste de esta voz (transporta la TAB, no el sonido)',
    'voices.transposeDesc': 'Instrumento transpositor (parte transportada, sonido en Do)',
    'structure.transpose': 'Transportar',
    'structure.transposeDownDesc': 'Transportar un semitono abajo (la tonalidad sigue)',
    'structure.transposeUpDesc': 'Transportar un semitono arriba (la tonalidad sigue)',
    'structure.swing': 'Swing',
    'structure.swingDesc': 'Sensación ternaria en reproducción (solo sonido)',
    'structure.swingOn': 'Swing ON',
    'structure.swingOff': 'Recta',
    'structure.swingAmountDesc': 'Intensidad del swing',
    'structure.swingLight': 'Suave',
    'structure.swingMedium': 'Medio',
    'structure.swingHard': 'Fuerte',
    'modifiers.arpeggio': 'Arpegio',
    'modifiers.arpeggioDesc': 'Arpegio (acorde desplegado de grave a agudo)',
    'modifiers.tremolo': 'Trémolo',
    'modifiers.tremoloDesc': 'Trémolo en la plica (1-3 trazos, visual)',
    'modifiers.breath': 'Respiración',
    'modifiers.breathDesc': 'Marca de respiración tras la nota',
    'modifiers.pedalStart': 'Pedal (inicio)',
    'modifiers.pedalStartDesc': 'Marcar inicio del pedal (Ped.)',
    'modifiers.pedalEnd': 'Pedal (fin)',
    'modifiers.pedalEndDesc': 'Marcar fin del pedal (*)',
    'modifiers.navFine': 'Fine',
    'modifiers.navFineDesc': 'Marca de fin (termina tras D.S./D.C.)',
    'modifiers.navToCoda': 'To Coda',
    'modifiers.navToCodaDesc': 'Punto de desvío a la Coda',
    'modifiers.navDsAlFine': 'D.S. al Fine',
    'modifiers.navDsAlFineDesc': 'Vuelve al Segno y termina en Fine',
    'modifiers.navDcAlFine': 'D.C. al Fine',
    'modifiers.navDcAlFineDesc': 'Vuelve al inicio y termina en Fine',
    'modifiers.navDsAlCoda': 'D.S. al Coda',
    'modifiers.navDsAlCodaDesc': 'Vuelve al Segno y desvía en To Coda',
    'modifiers.navDcAlCoda': 'D.C. al Coda',
    'modifiers.navDcAlCodaDesc': 'Vuelve al inicio y desvía en To Coda',

    // Accidentals Section
    'accidentals.title': 'Alteraciones',
    'accidentals.natural': 'Becuadro',
    'accidentals.sharp': 'Sostenido',
    'accidentals.flat': 'Bemol',
    'accidentals.doubleSharp': 'Doble Sostenido',
    'accidentals.doubleFlat': 'Doble Bemol',

    // Clefs Section
    'clefs.title': 'Clave Inline',
    'clefs.inlineTitle': 'Clave en Nota (Inline)',
    'clefs.treble': 'Sol',
    'clefs.trebleDesc': 'Insertar Clave de Sol Inline',
    'clefs.bass': 'Fa',
    'clefs.bassDesc': 'Insertar Clave de Fa Inline',
    'clefs.alto': 'Do',
    'clefs.altoDesc': 'Insertar Clave de Do (Alto) Inline',
    'clefs.tenor': 'Tenor',
    'clefs.tenorDesc': 'Insertar Clave de Tenor Inline',

    // Noteheads Section
    'noteheads.title': 'Cabeza de Nota',
    'noteheads.normalDesc': 'Cabeza oval estándar',
    'noteheads.xDesc': 'Cabeza en X (percusión / apagada)',
    'noteheads.diamondDesc': 'Cabeza rombo (armónico)',
    'noteheads.slashDesc': 'Cabeza barra (notación rítmica)',

    // Modifiers & Articulations Section
    'modifiers.title': 'Articulaciones & Puntillo',
    'modifiers.dotted': 'Nota con Puntillo',
    'modifiers.dottedDesc': 'Puntillo de aumento (Multiplica duración por 1.5)',
    'modifiers.staccato': 'Staccato',
    'modifiers.staccatoDesc': 'Staccato (punto sobre/bajo la nota)',
    'modifiers.accent': 'Acento (>)',
    'modifiers.accentDesc': 'Acento (>)',
    'modifiers.marcato': 'Marcato (^)',
    'modifiers.marcatoDesc': 'Marcato (^)',
    'modifiers.graceNote': 'Nota de Gracia ({g})',
    'modifiers.graceNoteDesc': 'Nota de Gracia / Apoyatura',
    'modifiers.glissando': 'Glissando',
    'modifiers.glissandoDesc': 'Glissando (línea ondulada)',
    'modifiers.cautionary': 'Alteración de Cortesía',
    'modifiers.cautionaryDesc': 'Alteración de precaución (entre paréntesis)',
    'modifiers.fermata': 'Calderón',
    'modifiers.fermataDesc': 'Calderón (𝄐)',
    'modifiers.downBow': 'Arco Abajo (⨅)',
    'modifiers.downBowDesc': 'Arco hacia abajo (Talón)',
    'modifiers.upBow': 'Arco Arriba (V)',
    'modifiers.upBowDesc': 'Arco hacia arriba (Punta)',
    'modifiers.tuplet': 'Tresillo (3:2)',
    'modifiers.tupletDesc': 'Tresillo (3 notas)',
    'modifiers.coda': 'Coda',
    'modifiers.codaDesc': 'Insertar Coda (𝄌)',
    'modifiers.segno': 'Segno',
    'modifiers.segnoDesc': 'Insertar Segno (𝄋)',
    'modifiers.trill': 'Trino (Trill)',
    'modifiers.trillDesc': 'Trino (tr)',
    'modifiers.turn': 'Grupeto',
    'modifiers.turnDesc': 'Grupeto (~)',
    'modifiers.mordent': 'Mordente',
    'modifiers.mordentDesc': 'Mordente',
    'modifiers.crescendo': 'Crescendo (<)',
    'modifiers.crescendoDesc': 'Crescendo (<)',
    'modifiers.diminuendo': 'Diminuendo (>)',
    'modifiers.diminuendoDesc': 'Diminuendo (>)',
    'modifiers.hairpinEnd': 'Fin de Regulador',
    'modifiers.hairpinEndDesc': 'Fin de expresión dinámica',

    // Ties & Slurs Section
    'ligatures.title': 'Ligaduras',
    'ligatures.tie': 'Lig. Prolongación',
    'ligatures.tieDesc': 'Ligar nota a la siguiente (Sostener)',
    'ligatures.slur': 'Lig. Expresión (Legato)',
    'ligatures.slurDesc': 'Alternar fraseo ligado',

    // Tablature Articulations Section
    'tabArticulations.title': 'Articulaciones TAB',
    'tabArticulations.slideUp': 'Slide Ascendente ( / )',
    'tabArticulations.slideUpDesc': 'Slide ascendente en la misma cuerda',
    'tabArticulations.slideDown': 'Slide Descendente ( \\ )',
    'tabArticulations.slideDownDesc': 'Slide descendente en la misma cuerda',
    'tabArticulations.bendFull': 'Bend Full (1)',
    'tabArticulations.bendFullDesc': 'Bend de 1 tono (Full)',
    'tabArticulations.bendHalf': 'Bend 1/2',
    'tabArticulations.bendHalfDesc': 'Bend de medio tono (1/2)',
    'tabArticulations.bendQuarter': 'Microbend 1/4',
    'tabArticulations.bendQuarterDesc': 'Microbend / Blues curl (1/4 tono)',
    'tabArticulations.bendRelease': 'Bend & Release',
    'tabArticulations.bendReleaseDesc': 'Bend con retorno a la nota original',
    'tabArticulations.hammerPull': 'Hammer / Pull (H/P)',
    'tabArticulations.hammerPullDesc': 'Ligadura Hammer-on (H) o Pull-off (P)',
    'tabArticulations.vibrato': 'Vibrato ( ~ )',
    'tabArticulations.vibratoDesc': 'Vibrato en la nota de la tablatura',
    'tabArticulations.harmonic': 'Armónico ( < > )',
    'tabArticulations.harmonicDesc': 'Armónico natural o artificial (<traste>)',
    'tabArticulations.deadNote': 'Nota Muerta ( X )',
    'tabArticulations.deadNoteDesc': 'Nota muteada percusiva',
    'tabArticulations.ghostNote': 'Nota Fantasma ( )',
    'tabArticulations.ghostNoteDesc': 'Nota fantasma tocada suavemente',
    'tabArticulations.palmMute': 'Palm Mute (P.M.)',
    'tabArticulations.palmMuteDesc': 'Técnica de silenciamiento con la palma',
    'tabArticulations.clear': 'Limpiar Articulaciones TAB',
    'tabArticulations.clearDesc': 'Quitar efectos y articulaciones TAB de la nota',
    'tabArticulations.fret': 'Traste',
    'tabArticulations.string': 'Cuerda',
    'tabArticulations.editHint': 'Haga clic en la cuerda TAB para añadir notas. Escriba 0–24 para cambiar el traste y use las flechas ↑↓←→ para navegar.',
    'tabArticulations.fretDesc': 'Número de traste en el diapasón de la guitarra',

    // Chords Section
    'chords.title': 'Acordes / Cifrado',
    'chords.placeholder': 'Ej: C, G7, Em, Am...',
    'chords.apply': 'Ok',
    'chords.applyDesc': 'Aplicar acorde en la nota seleccionada',
    'chords.remove': 'Quitar Acorde',
    'chords.guitarDiagrams': '🎸 Diagramas de Guitarra',
    'chords.guitarDiagramsDesc': 'Mostrar diagramas de acordes de guitarra',
    'chords.on': 'ON',
    'chords.off': 'OFF',

    // Structure Section
    'structure.title': 'Estructura',
    'structure.clef': 'Clave',
    'structure.clefTreble': 'Sol (Treble)',
    'structure.clefBass': 'Fa (Bass)',
    'structure.clefAlto': 'Do (Alto - 3ª Línea)',
    'structure.clefTenor': 'Do (Tenor - 4ª Línea)',
    'structure.clefPercussion': 'Percusión',
    'drums.title': 'Batería',
    'drums.kick': 'Bombo',
    'drums.kickDesc': 'Bombo (inserta en la voz activa)',
    'drums.snare': 'Caja',
    'drums.snareDesc': 'Caja (inserta en la voz activa)',
    'drums.hihat': 'Hi-hat',
    'drums.hihatDesc': 'Hi-hat cerrado (inserta en la voz activa)',
    'drums.hihatOpen': 'Hi-hat abierto',
    'drums.hihatOpenDesc': 'Hi-hat abierto (inserta en la voz activa)',
    'drums.tomHigh': 'Tom 1',
    'drums.tomHighDesc': 'Tom agudo (inserta en la voz activa)',
    'drums.tomMid': 'Tom 2',
    'drums.tomMidDesc': 'Tom medio (inserta en la voz activa)',
    'drums.tomFloor': 'Goliat',
    'drums.tomFloorDesc': 'Goliat (inserta en la voz activa)',
    'drums.crash': 'Crash',
    'drums.crashDesc': 'Plato crash (inserta en la voz activa)',
    'drums.ride': 'Ride',
    'drums.rideDesc': 'Plato ride (inserta en la voz activa)',
    'structure.timeSignature': 'Compás',
    'structure.keySignature': 'Tonalidad',
    'structure.major': 'Mayor',
    'structure.minor': 'Menor',
    'structure.lineBreak': 'Salto de Sistema',
    'structure.lineBreakDesc': 'Insertar salto de línea en esta nota',
    'structure.break': 'Romper',
    'structure.midChanges': 'Cambios en el compás',
    'structure.midKey': 'Tonalidad aquí',
    'structure.midKeyDesc': 'Insertar cambio de tonalidad en el compás de la nota seleccionada (usa Tonalidad)',
    'structure.midTime': 'Compás aquí',
    'structure.midTimeDesc': 'Insertar cambio de compás en el compás de la nota seleccionada (usa Compás)',
    'structure.rehearsal': 'Marca de ensayo',
    'structure.rehearsalDesc': 'Definir marca de ensayo en la nota seleccionada (vacío elimina)',
    'structure.rehearsalPrompt': 'Letra de la marca de ensayo (vacío elimina):',
    'structure.tempoChanges': 'Tempo',
    'structure.tempoBpm': 'BPM aquí',
    'structure.tempoBpmDesc': 'Cambio súbito de BPM en el compás de la nota seleccionada',
    'structure.tempoBpmPrompt': 'BPM en el compás (igual elimina):',
    'structure.rit': 'rit.',
    'structure.ritDesc': 'Ritenuto gradual hasta el final',
    'structure.ritPrompt': 'BPM objetivo del rit.:',
    'structure.accel': 'accel.',
    'structure.accelDesc': 'Accelerando gradual hasta el final',
    'structure.accelPrompt': 'BPM objetivo del accel.:',
    'print.pageOf': 'Página {n} de {total}',

    // Lyrics Section
    'lyrics.title': 'Letra (Lyrics)',
    'lyrics.helper': 'Separe sílabas con espacio o guion:',
    'lyrics.placeholder': 'Ej: Cam-pa-na so-bre cam-pa-na',
    'lyrics.apply': 'Aplicar Letra',
    'lyrics.applyDesc': 'Distribuir sílabas en las notas de la voz activa',
    'lyrics.clear': 'Limpar',
    'lyrics.clearDesc': 'Eliminar letras de la voz activa',
    'lyrics.verse1': 'Verso 1',
    'lyrics.verse1Desc': 'Aplicar letra al verso 1',
    'lyrics.verse2': 'Verso 2',
    'lyrics.verse2Desc': 'Aplicar letra al verso 2',

    // Voices Section
    'voices.title': 'Voces',
    'voices.select': 'Seleccionar {name}',
    'voices.hide': 'Ocultar',
    'voices.show': 'Mostrar',
    'voices.add': 'Agregar',
    'voices.addDesc': 'Agregar voz',
    'voices.part': 'Parte',
    'voices.allParts': 'Todas las voces',
    'voices.partDesc': 'Aislar una voz para estudio, reproducción, impresión y exportación (no altera la partitura)',
    'voices.remove': 'Eliminar',
    'voices.removeDesc': 'Eliminar voz activa',

    // Actions Section
    'actions.title': 'Acciones',
    'actions.undo': 'Deshacer',
    'actions.undoDesc': 'Deshacer (Ctrl+Z)',
    'actions.redo': 'Rehacer',
    'actions.redoDesc': 'Rehacer (Ctrl+Y)',
    'actions.clear': 'Limpiar',
    'actions.clearDesc': 'Limpiar partitura',
    'actions.remove': 'Eliminar',
    'tab.fretDown': '-1 Traste',
    'tab.fretUp': '+1 Traste',

    // Instruments
    'instruments.keys': 'Teclados',
    'instruments.grandPiano': 'Piano de Cola',
    'instruments.brightPiano': 'Piano Brillante',
    'instruments.harpsichord': 'Clavecín',
    'instruments.churchOrgan': 'Órgano de Tubos',
    'instruments.strings': 'Cuerdas',
    'instruments.nylonGuitar': 'Guitarra Clásica (Nailon)',
    'instruments.steelGuitar': 'Guitarra Acústica (Acero)',
    'instruments.violin': 'Violín',
    'instruments.cello': 'Violonchelo',
    'instruments.stringEnsemble': 'Orquesta de Cuerdas',
    'instruments.winds': 'Vientos & Metales',
    'instruments.flute': 'Flauta',
    'instruments.trumpet': 'Trompeta',
    'instruments.percussion': 'Percusión',
    'instruments.drumKit': 'Batería',

    // Footer
    'footer.notes': 'Notas',
    'footer.measures': 'Compases',
    'footer.tempo': 'Tempo',
    'footer.rightClickHint': 'Haga clic derecho en una nota para eliminarla',

    // Modals (Import / Export)
    'modal.importTitle': 'Importar Partitura',
    'modal.exportTitle': 'Exportar Partitura',
    'modal.loadSample': 'Cargar Ejemplo',
    'modal.pastePrompt': 'Pegue el contenido {format}:',
    'modal.cancel': 'Cancelar',
    'modal.processAndLoad': 'Procesar y Cargar',
    'modal.copy': 'Copiar',
    'modal.downloadFile': 'Descargar Archivo',
    'modal.copied': '¡Copiado al portapapeles!',

    // Dialogs / Prompts / Notifications
    'dialog.clearConfirm': '¿Está seguro de que desea limpiar la partitura? Se eliminarán todas las notas.',
    'dialog.exportSuccess': 'Partitura exportada con éxito.',
    'dialog.importError': 'Error al importar partitura.',
    'dialog.emptyScore': 'Partitura vacía.'
  },

  'fr': {
    // Top Toolbar & Common
    'score.defaultTitle': 'Ma Partition',
    'score.untitled': 'Sans titre',
    'toolbar.play': 'Lire la partition',
    'toolbar.stop': 'Arrêter la lecture',
    'toolbar.pause': 'Mettre en pause',
    'toolbar.listen': 'Écouter',
    'toolbar.stopBtn': 'Arrêter',
    'toolbar.tempo': 'Tempo (BPM)',
    'toolbar.keySignature': 'Armure',
    'toolbar.timeSignature': 'Chiffrage de mesure',
    'toolbar.zoomIn': 'Zoom avant',
    'toolbar.zoomOut': 'Zoom arrière',
    'toolbar.zoomReset': 'Réinitialiser le zoom',
    'toolbar.wrapMode': 'Mode d’affichage',
    'toolbar.wrapBreak': 'Retour à la ligne',
    'toolbar.wrapSingle': 'Ligne unique (Horizontal)',
    'toolbar.export': 'Exporter',
    'toolbar.import': 'Importer',
    'toolbar.save': 'Enregistrer',
    'toolbar.download': 'Télécharger',
    'toolbar.fullscreen': 'Plein écran',
    'toolbar.exitFullscreen': 'Quitter le plein écran',

    // Sidebar Header
    'sidebar.tools': 'Outils',
    'sidebar.expand': 'Déplier le panneau des outils',
    'sidebar.collapse': 'Replier le panneau',

    // Notes Section
    'notes.title': 'Notes',
    'notes.whole': 'Ronde',
    'notes.wholeDesc': 'Ronde (4 temps)',
    'notes.half': 'Blanche',
    'notes.halfDesc': 'Blanche (2 temps)',
    'notes.quarter': 'Noire',
    'notes.quarterDesc': 'Noire (1 temps)',
    'notes.eighth': 'Croche',
    'notes.eighthDesc': 'Croche (1/2 temps)',
    'notes.sixteenth': 'Double-croche',
    'notes.sixteenthDesc': 'Double-croche (1/4 de temps)',
    'notes.thirtySecond': 'Triple-croche',
    'notes.thirtySecondDesc': 'Triple-croche (1/8 de temps)',
    'notes.stackHint': 'Alt+clic sur une note sélectionnée : empiler une note (accord). Alt+clic droit supprime la note.',

    // Rests Section
    'rests.title': 'Silences',
    'rests.whole': 'Pause — 4T',
    'rests.wholeDesc': 'Pause (4 temps)',
    'rests.half': 'Demi-pause — 2T',
    'rests.halfDesc': 'Demi-pause (2 temps)',
    'rests.quarter': 'Soupir — 1T',
    'rests.quarterDesc': 'Soupir (1 temps)',
    'rests.eighth': 'Demi-soupir — 1/2',
    'rests.eighthDesc': 'Demi-soupir (1/2 temps)',
    'rests.sixteenth': 'Quart de soupir — 1/4',
    'rests.sixteenthDesc': 'Quart de soupir (1/4 de temps)',
    'rests.thirtySecond': 'Huitième de soupir — 1/8',
    'rests.thirtySecondDesc': 'Huitième de soupir (1/8 de temps)',
    'rests.multi': 'Bâton de mesure',
    'rests.multiDesc': 'Silence multi-mesures sur le silence sélectionné',
    'rests.multiPrompt': 'Nombre de mesures (2-32, vide pour retirer) :',
    'modifiers.ottava8va': '8va (octave au-dessus)',
    'modifiers.ottava8vaDesc': 'Commencer le passage 8va sur la note sélectionnée',
    'modifiers.ottava8vb': '8vb (octave en dessous)',
    'modifiers.ottava8vbDesc': 'Commencer le passage 8vb sur la note sélectionnée',
    'modifiers.ottavaEnd': 'Fin 8va/8vb',
    'modifiers.ottavaEndDesc': 'Terminer le passage d’octave sur la note sélectionnée',
    'voices.staff': 'Portée {n}',
    'voices.newStaff': '+ Nouvelle portée',
    'voices.staffDesc': 'Portée de cette voix (les voix partageant une portée séparent les hampes)',
    'voices.tabDesc': 'Afficher la tablature sous la portée (cliquez à nouveau pour TAB seule)',
    'voices.tabOnlyActive': 'Mode TAB seule actif (cliquez pour désactiver)',
    'voices.capo': 'Capo {n}',
    'voices.capoNone': 'Sans capo',
    'voices.capoDesc': 'Capodastre pour cette voix (transpose la TAB, pas le son)',
    'voices.transposeDesc': 'Instrument transpositeur (la partition affiche transposé, son réel en Ut)',
    'structure.transpose': 'Transposer',
    'structure.transposeDownDesc': 'Transposer d’un demi-ton vers le bas (l’armure s’adapte)',
    'structure.transposeUpDesc': 'Transposer d’un demi-ton vers le haut (l’armure s’adapte)',
    'structure.swing': 'Swing',
    'structure.swingDesc': 'Balancement ternaire en lecture (son uniquement)',
    'structure.swingOn': 'Swing ON',
    'structure.swingOff': 'Binaire',
    'structure.swingAmountDesc': 'Intensité du swing',
    'structure.swingLight': 'Léger',
    'structure.swingMedium': 'Moyen',
    'structure.swingHard': 'Fort',
    'modifiers.arpeggio': 'Arpège',
    'modifiers.arpeggioDesc': 'Arpège (accord égrené de bas en haut)',
    'modifiers.tremolo': 'Trémolo',
    'modifiers.tremoloDesc': 'Trémolo sur la hampe (1 à 3 barres, visuel)',
    'modifiers.breath': 'Respiration',
    'modifiers.breathDesc': 'Marque de respiration après la note',
    'modifiers.pedalStart': 'Pédale (début)',
    'modifiers.pedalStartDesc': 'Marquer le début de pédale (Ped.)',
    'modifiers.pedalEnd': 'Pédale (fin)',
    'modifiers.pedalEndDesc': 'Marquer la fin de pédale (*)',
    'modifiers.navFine': 'Fine',
    'modifiers.navFineDesc': 'Fin du morceau (s’arrête après D.S./D.C.)',
    'modifiers.navToCoda': 'To Coda',
    'modifiers.navToCodaDesc': 'Point de renvoi vers la Coda',
    'modifiers.navDsAlFine': 'D.S. al Fine',
    'modifiers.navDsAlFineDesc': 'Retour au Segno, s’arrête à Fine',
    'modifiers.navDcAlFine': 'D.C. al Fine',
    'modifiers.navDcAlFineDesc': 'Retour au début, s’arrête à Fine',
    'modifiers.navDsAlCoda': 'D.S. al Coda',
    'modifiers.navDsAlCodaDesc': 'Retour au Segno, renvoi à To Coda',
    'modifiers.navDcAlCoda': 'D.C. al Coda',
    'modifiers.navDcAlCodaDesc': 'Retour au début, renvoi à To Coda',

    // Accidentals Section
    'accidentals.title': 'Altérations',
    'accidentals.natural': 'Bécarre',
    'accidentals.sharp': 'Dièse',
    'accidentals.flat': 'Bémol',
    'accidentals.doubleSharp': 'Double dièse',
    'accidentals.doubleFlat': 'Double bémol',

    // Clefs Section
    'clefs.title': 'Clé en ligne',
    'clefs.inlineTitle': 'Clé sur la note (en ligne)',
    'clefs.treble': 'Sol',
    'clefs.trebleDesc': 'Insérer une clé de Sol en ligne',
    'clefs.bass': 'Fa',
    'clefs.bassDesc': 'Insérer une clé de Fa en ligne',
    'clefs.alto': 'Ut (Alto)',
    'clefs.altoDesc': 'Insérer une clé d’Ut 3e en ligne',
    'clefs.tenor': 'Ténor',
    'clefs.tenorDesc': 'Insérer une clé d’Ut 4e en ligne',

    // Noteheads Section
    'noteheads.title': 'Tête de note',
    'noteheads.normalDesc': 'Tête ovale standard',
    'noteheads.xDesc': 'Tête en croix (percussion / étouffée)',
    'noteheads.diamondDesc': 'Tête en losange (harmonique)',
    'noteheads.slashDesc': 'Tête en barre oblique (notation rythmique)',

    // Modifiers & Articulations Section
    'modifiers.title': 'Articulations & Point',
    'modifiers.dotted': 'Note pointée',
    'modifiers.dottedDesc': 'Point d’augmentation (multiplie la durée par 1.5)',
    'modifiers.staccato': 'Staccato',
    'modifiers.staccatoDesc': 'Staccato (point au-dessus/en dessous de la note)',
    'modifiers.accent': 'Accent (>)',
    'modifiers.accentDesc': 'Accent (>)',
    'modifiers.marcato': 'Marcato (^)',
    'modifiers.marcatoDesc': 'Marcato (^)',
    'modifiers.graceNote': 'Appoggiature ({g})',
    'modifiers.graceNoteDesc': 'Petite note / Appoggiature ({g})',
    'modifiers.glissando': 'Glissando',
    'modifiers.glissandoDesc': 'Glissando (ligne ondulée vers la note suivante)',
    'modifiers.cautionary': 'Altération de précaution',
    'modifiers.cautionaryDesc': 'Altération de précaution (entre parenthèses)',
    'modifiers.fermata': 'Point d’orgue',
    'modifiers.fermataDesc': 'Point d’orgue (𝄐)',
    'modifiers.downBow': 'Tirez (⨅)',
    'modifiers.downBowDesc': 'Coup d’archet vers le bas / Talon (⨅)',
    'modifiers.upBow': 'Poussez (V)',
    'modifiers.upBowDesc': 'Coup d’archet vers le haut / Pointe (V)',
    'modifiers.tuplet': 'Triolet (3:2)',
    'modifiers.tupletDesc': 'Triolet (division de 3 notes)',
    'modifiers.coda': 'Coda',
    'modifiers.codaDesc': 'Insérer une Coda (𝄌)',
    'modifiers.segno': 'Segno',
    'modifiers.segnoDesc': 'Insérer un Segno (𝄋)',
    'modifiers.trill': 'Trille (tr)',
    'modifiers.trillDesc': 'Trille (tr)',
    'modifiers.turn': 'Gruppetto',
    'modifiers.turnDesc': 'Gruppetto (~)',
    'modifiers.mordent': 'Mordant',
    'modifiers.mordentDesc': 'Mordant',
    'modifiers.crescendo': 'Crescendo (<)',
    'modifiers.crescendoDesc': 'Crescendo (<)',
    'modifiers.diminuendo': 'Diminuendo (>)',
    'modifiers.diminuendoDesc': 'Diminuendo (>)',
    'modifiers.hairpinEnd': 'Fin du soufflet',
    'modifiers.hairpinEndDesc': 'Fin de nuance dynamique',

    // Ties & Slurs Section
    'ligatures.title': 'Liaisons',
    'ligatures.tie': 'Liaison de tenue',
    'ligatures.tieDesc': 'Lier la note à la suivante (Prolongation)',
    'ligatures.slur': 'Liaison de phrasé (Legato)',
    'ligatures.slurDesc': 'Activer/désactiver la liaison de phrasé',

    // Tablature Articulations Section
    'tabArticulations.title': 'Articulations TAB',
    'tabArticulations.slideUp': 'Slide Montant ( / )',
    'tabArticulations.slideUpDesc': 'Glissé montant sur la même corde',
    'tabArticulations.slideDown': 'Slide Descendant ( \\ )',
    'tabArticulations.slideDownDesc': 'Glissé descendant sur la même corde',
    'tabArticulations.bendFull': 'Bend 1 ton (1)',
    'tabArticulations.bendFullDesc': 'Bend d’un ton complet',
    'tabArticulations.bendHalf': 'Bend 1/2 ton',
    'tabArticulations.bendHalfDesc': 'Bend d’un demi-ton',
    'tabArticulations.bendQuarter': 'Microbend 1/4',
    'tabArticulations.bendQuarterDesc': 'Microbend blues de quart de ton',
    'tabArticulations.bendRelease': 'Bend & Release',
    'tabArticulations.bendReleaseDesc': 'Bend puis retour à la frette initiale',
    'tabArticulations.hammerPull': 'Hammer / Pull (H/P)',
    'tabArticulations.hammerPullDesc': 'Hammer-on (H) ou Pull-off (P) lié',
    'tabArticulations.vibrato': 'Vibrato ( ~ )',
    'tabArticulations.vibratoDesc': 'Vibrato au doigt ou au vibrato',
    'tabArticulations.harmonic': 'Harmonique ( < > )',
    'tabArticulations.harmonicDesc': 'Harmonique naturelle ou artificielle',
    'tabArticulations.deadNote': 'Note étouffée ( X )',
    'tabArticulations.deadNoteDesc': 'Frappe étouffée percussive',
    'tabArticulations.ghostNote': 'Note fantôme ( )',
    'tabArticulations.ghostNoteDesc': 'Note jouée très doucement',
    'tabArticulations.palmMute': 'Palm Mute (P.M.)',
    'tabArticulations.palmMuteDesc': 'Étompement avec la paume',
    'tabArticulations.clear': 'Effacer articulations TAB',
    'tabArticulations.clearDesc': 'Retirer les effets et articulations de la note',
    'tabArticulations.fret': 'Frette',
    'tabArticulations.string': 'Corde',
    'tabArticulations.editHint': 'Cliquez sur la corde TAB pour ajouter des notes. Tapez 0–24 pour changer la frette et naviguez avec les flèches.',
    'tabArticulations.fretDesc': 'Numéro de frette sur le manche',

    // Chords Section
    'chords.title': 'Accords & Grilles',
    'chords.placeholder': 'Ex. : C, G7, Em, Am...',
    'chords.apply': 'Appliquer',
    'chords.applyDesc': 'Appliquer le symbole d’accord à la note',
    'chords.remove': 'Supprimer l’accord',
    'chords.guitarDiagrams': '🎸 Diagrammes d’accords',
    'chords.guitarDiagramsDesc': 'Afficher/masquer les diagrammes de guitare',
    'chords.on': 'OUI',
    'chords.off': 'NON',

    // Structure Section
    'structure.title': 'Structure',
    'structure.clef': 'Clé',
    'structure.clefTreble': 'Sol',
    'structure.clefBass': 'Fa',
    'structure.clefAlto': 'Ut (3e)',
    'structure.clefTenor': 'Ut (4e)',
    'structure.clefPercussion': 'Percussion',
    'drums.title': 'Batterie',
    'drums.kick': 'Grosse caisse',
    'drums.kickDesc': 'Grosse caisse (insère dans la voix active)',
    'drums.snare': 'Caisse claire',
    'drums.snareDesc': 'Caisse claire (insère dans la voix active)',
    'drums.hihat': 'Charleston',
    'drums.hihatDesc': 'Charleston fermé (insère dans la voix active)',
    'drums.hihatOpen': 'Charleston ouvert',
    'drums.hihatOpenDesc': 'Charleston ouvert (insère dans la voix active)',
    'drums.tomHigh': 'Tom aigu',
    'drums.tomHighDesc': 'Tom aigu (insère dans la voix active)',
    'drums.tomMid': 'Tom médium',
    'drums.tomMidDesc': 'Tom médium (insère dans la voix active)',
    'drums.tomFloor': 'Tom basse',
    'drums.tomFloorDesc': 'Tom basse (insère dans la voix active)',
    'drums.crash': 'Crash',
    'drums.crashDesc': 'Cymbale crash (insère dans la voix active)',
    'drums.ride': 'Ride',
    'drums.rideDesc': 'Cymbale ride (insère dans la voix active)',
    'structure.timeSignature': 'Chiffrage',
    'structure.keySignature': 'Tonalité',
    'structure.major': 'Majeur',
    'structure.minor': 'Mineur',
    'structure.lineBreak': 'Saut de système',
    'structure.lineBreakDesc': 'Insérer un saut de ligne sur cette note',
    'structure.break': 'Sauter la ligne',
    'structure.midChanges': 'Changements en cours',
    'structure.midKey': 'Tonalité ici',
    'structure.midKeyDesc': 'Changer d’armure à la mesure de la note sélectionnée',
    'structure.midTime': 'Chiffrage ici',
    'structure.midTimeDesc': 'Changer de chiffrage à la mesure de la note sélectionnée',
    'structure.rehearsal': 'Repère',
    'structure.rehearsalDesc': 'Définir une lettre de repère sur la note (vide pour retirer)',
    'structure.rehearsalPrompt': 'Lettre de repère (vide pour retirer) :',
    'structure.tempoChanges': 'Tempo',
    'structure.tempoBpm': 'BPM ici',
    'structure.tempoBpmDesc': 'Changement brusque de tempo à cette mesure',
    'structure.tempoBpmPrompt': 'Nouveau BPM à la mesure (identique pour retirer) :',
    'structure.rit': 'rit.',
    'structure.ritDesc': 'Ralentissement progressif (ritenuto)',
    'structure.ritPrompt': 'BPM cible pour le rit. :',
    'structure.accel': 'accel.',
    'structure.accelDesc': 'Accélération progressive (accelerando)',
    'structure.accelPrompt': 'BPM cible pour l’accel. :',
    'print.pageOf': 'Page {n} sur {total}',

    // Lyrics Section
    'lyrics.title': 'Paroles',
    'lyrics.helper': 'Séparez les syllabes par un espace ou un tiret :',
    'lyrics.placeholder': 'Ex. : Au clair de la lu-ne',
    'lyrics.apply': 'Appliquer les paroles',
    'lyrics.applyDesc': 'Distribuer les syllabes sur les notes de la voix active',
    'lyrics.clear': 'Effacer',
    'lyrics.clearDesc': 'Supprimer les paroles de la voix active',
    'lyrics.verse1': 'Couplet 1',
    'lyrics.verse1Desc': 'Appliquer au couplet 1',
    'lyrics.verse2': 'Couplet 2',
    'lyrics.verse2Desc': 'Appliquer au couplet 2',

    // Voices Section
    'voices.title': 'Voix',
    'voices.select': 'Sélectionner {name}',
    'voices.hide': 'Masquer',
    'voices.show': 'Afficher',
    'voices.add': 'Ajouter',
    'voices.addDesc': 'Ajouter une voix',
    'voices.part': 'Partie',
    'voices.allParts': 'Toutes les voix',
    'voices.partDesc': 'Isoler une voix pour le travail, la lecture, l’impression et l’export',
    'voices.remove': 'Supprimer',
    'voices.removeDesc': 'Supprimer la voix active',

    // Actions Section
    'actions.title': 'Actions',
    'actions.undo': 'Annuler',
    'actions.undoDesc': 'Annuler (Ctrl+Z)',
    'actions.redo': 'Rétablir',
    'actions.redoDesc': 'Rétablir (Ctrl+Y)',
    'actions.clear': 'Effacer',
    'actions.clearDesc': 'Effacer la partition',
    'actions.remove': 'Supprimer',
    'tab.fretDown': '-1 Frette',
    'tab.fretUp': '+1 Frette',

    // Instruments
    'instruments.keys': 'Claviers',
    'instruments.grandPiano': 'Piano à Queue',
    'instruments.brightPiano': 'Piano Brillant',
    'instruments.harpsichord': 'Clavecin',
    'instruments.churchOrgan': 'Orgue d’Église',
    'instruments.strings': 'Cordes',
    'instruments.nylonGuitar': 'Guitare Classique (Nylon)',
    'instruments.steelGuitar': 'Guitare Folk (Acier)',
    'instruments.violin': 'Violon',
    'instruments.cello': 'Violoncelle',
    'instruments.stringEnsemble': 'Ensemble de Cordes',
    'instruments.winds': 'Vents & Cuivres',
    'instruments.flute': 'Flûte Traversière',
    'instruments.trumpet': 'Trompette',
    'instruments.percussion': 'Percussion',
    'instruments.drumKit': 'Batterie (Drum Kit)',

    // Footer
    'footer.notes': 'Notes',
    'footer.measures': 'Mesures',
    'footer.tempo': 'Tempo',
    'footer.rightClickHint': 'Clic droit sur une note pour la supprimer',

    // Modals (Import / Export)
    'modal.importTitle': 'Importer une Partition',
    'modal.exportTitle': 'Exporter la Partition',
    'modal.loadSample': 'Charger un Exemple',
    'modal.pastePrompt': 'Collez le contenu {format} :',
    'modal.cancel': 'Annuler',
    'modal.processAndLoad': 'Traiter et Charger',
    'modal.copy': 'Copier',
    'modal.downloadFile': 'Télécharger le fichier',
    'modal.copied': 'Copié dans le presse-papiers !',

    // Dialogs / Prompts / Notifications
    'dialog.clearConfirm': 'Voulez-vous vraiment effacer la partition ? Toutes les notes seront supprimées.',
    'dialog.exportSuccess': 'Partition exportée avec succès.',
    'dialog.importError': 'Erreur lors de l’importation de la partition.',
    'dialog.emptyScore': 'Partition vide.'
  }
};

/**
 * Normaliza o código de locale para um dos suportados ('pt-BR', 'en', 'es', 'fr').
 * @param {string} [loc]
 * @returns {string}
 */
export function normalizeLocale(loc) {
  if (!loc) return 'pt-BR';
  const l = String(loc).trim().replace('_', '-');
  const lower = l.toLowerCase();
  if (lower.startsWith('pt')) return 'pt-BR';
  if (lower.startsWith('es')) return 'es';
  if (lower.startsWith('fr')) return 'fr';
  if (lower.startsWith('en')) return 'en';
  return l;
}

/**
 * Retorna o texto traduzido para uma dada chave e parâmetros de interpolação.
 * @param {string} key - Chave de tradução (ex: 'notes.quarter')
 * @param {Record<string, any>} [params] - Parâmetros para interpolação (ex: { name: 'Voz 1' })
 * @param {string} [locale='pt-BR'] - Código do idioma
 * @param {Record<string, string>} [customLabels={}] - Dicionário de sobrescrita passado via props
 * @returns {string} Texto formatado
 */
export function getMusicSheetLabel(key, params = {}, locale = 'pt-BR', customLabels = {}) {
  const normLocale = normalizeLocale(locale);
  let val = customLabels && customLabels[key];
  if (val === undefined || val === null) {
    const dict = DEFAULT_LOCALES[normLocale] || DEFAULT_LOCALES['pt-BR'] || {};
    val = dict[key];
  }
  if (val === undefined || val === null) {
    const fallbackDict = DEFAULT_LOCALES['en'] || DEFAULT_LOCALES['pt-BR'] || {};
    val = fallbackDict[key] || key;
  }

  if (typeof val !== 'string') {
    return String(val ?? key);
  }

  if (params && Object.keys(params).length > 0) {
    return val.replace(/\{(\w+)\}/g, (_, p) => (params[p] !== undefined ? params[p] : `{${p}}`));
  }

  return val;
}
